// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function PrivacySlide() {
  return (
    <div className="slide-content centered">
      {/* <img src="./assets/app-icon.png" alt="Privacy" className="app-icon-medium" /> */}
      <h2 className="slide-title">Your Privacy Matters</h2>
      <div className="feature-list">
        <div className="feature-item">
          <div className="feature-icon">✓</div>
          <div className="feature-text">
            <strong>Local file organization</strong>
            <p>Tagging, rating, and commenting on your files happen on your computer.</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-icon">✓</div>
          <div className="feature-text">
            <strong>Zero Tracking</strong>
            <p>No analytics, no telemetry, no data collection</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-icon">✓</div>
          <div className="feature-text">
            <strong>Licensing is the only exception</strong>
            <p>Unlocking the app sends us your purchase email address, this computer's name, and an identifier for this installation — nothing else, and never your files.</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-icon">✓</div>
          <div className="feature-text">
            <strong>Choose local or cloud AI</strong>
            <p>Tag Sense AI runs locally. AI Hotkeys+ can use a local model or send selected content to a cloud provider when you choose a cloud action.</p>
          </div>
        </div>
      </div>
      <p className="slide-note">
        Your productivity tools, your privacy, your control
      </p>
    </div>
  )
}

export default PrivacySlide
